module.exports = __webpack_public_path__ + "img/product14.bfadd8ff.png";